import {Component} from '@angular/core';


@Component({
  selector: 'app-loading',
  template: `
    <div style="position: fixed;width: 100vw;height: 100vh;background-color: #efeff6;z-index: 99999;top: 0;left: 0;">
      <div class="loader">Loading...</div>
    </div>`,
})
export class LoadingComponent {
}
